module.exports = __webpack_public_path__ + "img/stream_placeholder.6ef7466.jpg";